const state = {
  karats: [{ name: '14' }, { name: '18' }, { name: '21' }, { name: '24' }, { name: 'Others' }],
  paginationcount: [{ name: '5' }, { name: '10' }, { name: '25' }, { name: '50' }]
};

export default {
  namespaced: true,
  state,
  actions: {
    fetchKarats({ commit }, payload) {},
    fetchPaginationCount({ commit }, payload) {}
  }
};
